import { type ExtraValues, type PlatformEvent } from '../types';

export const adIsFailedEvent = (extra: ExtraValues): PlatformEvent => {
  return {
    type: 'ad',
    created: Date.now(),
    user_properties: {
      ...(extra && { ...extra.user_properties }),
    },
    event_properties: {
      name: 'view_failed',
      ...extra.event_properties,
    },
  };
};
